import 'regenerator-runtime/runtime.js'
// required to import languages setup first
import './i18n/shared/i18n-setup'
import createOmnitechApp from './omnitech-app'
import { cancelRequest, getCommerceChannel } from './helpers'
import { metricsApi } from './metrics'
import { useAddresses } from './addresses'
import { useArticles } from './articles'
import { useArticlesCategories } from './articles-categories'
import { useAttachment } from './attachment'
import { useAuth, useSmsToken, useEmailToken } from './auth'
import { useBackInStockNotifications } from './back-in-stock-notifications'
import { useBeautyAssistantSessions } from './beauty-assistant-sessions'
import { useBookings } from './bookings'
import { useBrands } from './brands'
import { useCart } from './cart'
import { useCartShipments } from './cart-shipments'
import { useCategories } from './categories'
import { useClasses } from './classes'
import { useColorMasters } from './color-masters'
import { useCommerceChannels } from './commerce-channels'
import { useContentGroups } from './content-groups'
import { useCoupons } from './coupons'
import { useCouponTokens } from './coupon-tokens'
import { useCouponUsages } from './coupon-usages'
import { useCurrencies } from './currencies'
import { useDataBins } from './data-bins'
import { useDeliveryAddresses } from './delivery-addresses'
import { useDepartments } from './departments'
import { useDineInCart } from './dine-in-cart'
import { useDisableCheckouts } from './disable-checkouts'
import { useFavourites } from './favourites'
import { useI18n } from './i18n'
import { useLoyaltyPointTransactions } from './loyalty-point-transactions'
import { useMetaDefinitions } from './meta-definitions'
import { useOmnitechApp } from './omnitech-app/shared'
import { useOrderMethod } from './order-method'
import { useOrderMethods } from './order-methods'
import { useOrders } from './orders'
import { usePages } from './pages'
import { usePayment } from './payment'
import { usePhones } from './phones'
import { useProductDetailAttr } from './product-detail-attr'
import { useProductGroups } from './product-groups'
import { useProducts } from './products'
import { useRecommendations } from './recommendations'
import { useReviews } from './reviews'
import { useSizeMasters } from './size-masters'
import { useSkuQuotaMasters } from './sku-quota-masters'
import { useSkus } from './skus'
import { useStaffs } from './staffs'
import { useStockCounters } from './stock-counters'
import { useStoredValueTransactions } from './stored-value-transactions'
import { useStores } from './stores'
import { useSupportTicket } from './support-ticket'
import { useSystemSettings } from './system-settings'
import { useTenants } from './tenants'
import { useUser } from './users'
import { useUserPreferences } from './user-preferences'

// omnitech app HOC creator
export default createOmnitechApp

export {
  // api
  metricsApi,

  // helpers
  cancelRequest,
  getCommerceChannel,

  // custom hooks for providing Omnitech API function
  useAddresses,
  useArticles,
  useArticlesCategories,
  useAttachment,
  useAuth,
  useBackInStockNotifications,
  useBeautyAssistantSessions,
  useBookings,
  useBrands,
  useCart,
  useCartShipments,
  useCategories,
  useClasses,
  useColorMasters,
  useCommerceChannels,
  useContentGroups,
  useCoupons,
  useCouponTokens,
  useCouponUsages,
  useCurrencies,
  useDataBins,
  useDeliveryAddresses,
  useDepartments,
  useDineInCart,
  useDisableCheckouts,
  useEmailToken,
  useFavourites,
  useI18n,
  useLoyaltyPointTransactions,
  useMetaDefinitions,
  useOmnitechApp,
  useOrderMethod,
  useOrderMethods,
  useOrders,
  usePages,
  usePayment,
  usePhones,
  useProductDetailAttr,
  useProductGroups,
  useProducts,
  useRecommendations,
  useReviews,
  useSizeMasters,
  useSkuQuotaMasters,
  useSkus,
  useStaffs,
  useStockCounters,
  useStoredValueTransactions,
  useSmsToken,
  useStores,
  useSupportTicket,
  useSystemSettings,
  useTenants,
  useUser,
  useUserPreferences
}
